import React from 'react';
import styles from 'src/components/navigation/globalFooter.module.scss';
import dlsContentStyles from 'src/styles/dlsContentStyles.module.scss';
import { DlsTypographyVariants } from 'src/types/dls-typography-variants.enum';
import LiteralsService from 'src/services/literals/LiteralsService';
import { SPENDSMART_TERMS_AND_CONDITIONS } from 'src/utils/constants';
import adobeTags from 'src/types/adobe-tags';
import Anchor from 'src/components/atomic/atoms/anchor/Anchor';
import { useGlobalFooter } from 'src/hooks/queries/navigation';
import { isMobileApp } from 'src/utils/url.utils';

export default function GlobalFooter({ showTermsAndConditions }: { showTermsAndConditions?: boolean }): JSX.Element {
    const { data: globalFooter } = useGlobalFooter();
    const showGlobalFooter = globalFooter && !isMobileApp();

    return (
        <>
            {showTermsAndConditions && (
                <div role="complementary" className={styles.termsAndConditionsContainer}>
                    <p
                        className={`${DlsTypographyVariants.BODY_1} ${dlsContentStyles.dlsView} ${dlsContentStyles.dlsContainer}`}
                    >
                        {LiteralsService.getLiteral('Budget.Settings.moreInfo')}
                        <Anchor href={SPENDSMART_TERMS_AND_CONDITIONS} tag={adobeTags.Footer} inline>
                            {LiteralsService.getLiteral('Budget.Settings.termsAndConditions')}
                        </Anchor>
                    </p>
                </div>
            )}
            {showGlobalFooter && <div dangerouslySetInnerHTML={{ __html: globalFooter }} />}
        </>
    );
}
